import React, {useCallback, useEffect, useState} from "react";
import Prev from "../../assets/image/icon_prev.svg";
import Toggle from "../component/Toggle";
import {useHistory} from "react-router-dom";
import { isMobileApp } from "@common/utils/app/appUtils";
import WebviewMessage, { RN_APP_API_TYPE } from "@common/components/appConnect/WebviewMessage";
import {getAlarmSettings, updateAlarmSettings} from "@common/services/restapi/mypage/index"

const ALARM_SETTINGS = {
  SERVICE_ALARM: {
    name: "service_alarm",
    defaultActive: true,
    title: "서비스 알림",
    subText: "광고 소식 및 광고물 제공 신청 처리"
  }
};

function Setting () {
  const history = useHistory();
  const [alarmSettings, setAlarmSettings] = useState(null);

  const handleGoBack = useCallback(() => {
    history.goBack();
  },[]);

  useEffect(() => {
    if (isMobileApp()) {
      const getDeviceState = async () => {
        return await WebviewMessage(RN_APP_API_TYPE.GET_DEVICE_STATE).catch(() => null);
      };
      (async () => {
        const deviceState = await getDeviceState();
        if (deviceState) {
          const settings = await getAlarmSettings({playerId: deviceState.userId});
          if (settings) {
            setAlarmSettings(settings);
          }
        }
      })()
    }
  }, []);

  const handleChangeSettings = async (alarmSettings) => {
    const settings = await updateAlarmSettings(alarmSettings);
    if (settings) {
      setAlarmSettings(settings);
    }
  };

  return (
    <>
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">알림설정</h3>
      </div>
      <SettingToggleView alarmSettings={alarmSettings} alarmType={ALARM_SETTINGS.SERVICE_ALARM} onChangeSetting={handleChangeSettings} />

      {isMobileApp() && <AppVersionInfo />}
      <DeviceInfoView alarmSettings={alarmSettings} />
    </>
  )
}

function AppVersionInfo() {
  const [currentVersion, setCurrentVersion] = useState(null);
  const [latestVersion, setLatestVersion] = useState(null);

  useEffect(() => {
    const getAppCurrentVersion = async () => {
      return await WebviewMessage(RN_APP_API_TYPE.GET_APP_CURRENT_VERSION).catch(() => null);
    };
    (async () => {
      const appCurrentVersion = await getAppCurrentVersion();
      if (appCurrentVersion) {
        setCurrentVersion(appCurrentVersion);
      }
    })();

    // const getAppLatestVersion = async () => {
    //   return await WebviewMessage(RN_APP_API_TYPE.GET_APP_LATEST_VERSION).catch(() => null);
    // };
    // (async () => {
    //   const appLatestVersion = await getAppLatestVersion();
    //   if (appLatestVersion) {
    //     setLatestVersion(appLatestVersion);
    //   }
    // })()
  }, []);

  if (!currentVersion) return <></>;

  return (
    <section>
      <div className="section-body">
        버전정보
        <span className="current-version">{currentVersion}</span>
        {!latestVersion ? (
          <></>
        ) : currentVersion === latestVersion ? (
          <label className="isNew">최신버전입니다.</label>
        ) : (
          <label className="isNew">업데이트가 필요합니다.</label>
        )}
      </div>
    </section>
  );
}

function SettingToggleView({alarmSettings, alarmType, onChangeSetting}) {
  const [toggleSwitch, setToggleSwitch] = useState(alarmType.defaultActive);

  function getValue() {
    if (!alarmSettings) return alarmType.defaultActive;
    switch (alarmType.name) {
      case "service_alarm" :
        return alarmSettings.serviceAlarmEnabled === 1;
    }
  }

  useEffect(() => {
    if (alarmSettings) {
      setToggleSwitch(getValue());
    }
  }, [alarmSettings]);

  const changeSetting = (event) => {
    const {target} = event;
    switch (alarmType.name) {
      case "service_alarm" :
        alarmSettings.serviceAlarmEnabled = target.checked;
        break;
    }

    onChangeSetting(alarmSettings);
  };

  if (!alarmSettings) return null;

  return (
    <div className="alert-section-box first mt-56">
      <div className="left-box">
        <div className="headline">{alarmType.title}</div>
        <div className="summary">{alarmType.subText && alarmType.subText}</div>
      </div>
      <div className="right-box">
        <Toggle defaultChecked={toggleSwitch} onToggleChange={changeSetting} />
      </div>
    </div>
  );
}

function DeviceInfoView({alarmSettings}) {
  if (!alarmSettings) return null;

  return (
    <>
      {
        process.env.PROFILE !== 'production' &&
        <div className="alert-section-box first mt-56">
          <div className="left-box">
            <div className="headline">Player ID</div>
          </div>
          <div className="right-box">
            <span>{alarmSettings && alarmSettings.playerId}</span>
          </div>
        </div>
      }
    </>
  )
}

export default Setting
